import Backbone from 'backbone';

export var ChannelsModel = Backbone.Model.extend({
  url: 'channels',

  initialize: function () {},

  parse: function (res) {
    return res.result;
  }
});
